import Loadable from "app/components/Loadable";
import { PERMISSIONS } from "app/utils/permissions";
import { lazy } from "react";

const DailyFieldActivityReport = Loadable(
  lazy(() => import("./DailyFieldActivityReport"))
);

const dailyFieldActivityRoutes = [
  {
    path: "/DailyFieldActivity/DailyFieldActivityReport",
    element: <DailyFieldActivityReport />,
    permission: PERMISSIONS.DailyFieldActivity.Menu,
  },
];
export default dailyFieldActivityRoutes;
